import type { ComponentProps } from 'react';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';

type SkeletonProps = Pick<
	ComponentProps<typeof GovSkeleton>,
	'height' | 'width' | 'shape'
> & {
	ariaLabel?: string;
};

export const Skeleton = ({ ariaLabel, ...rest }: SkeletonProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Global);

	return (
		<GovSkeleton
			{...rest}
			aria-label={ariaLabel ?? t('loading.wcag.processing')}
		/>
	);
};
